var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.25,
    height: 13.75,
    viewBox: "0 0 11.25 13.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text",
    "data-name": "Icon feather-file-text",
    transform: "translate(-1.875 -0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35714",
    "data-name": "Path 35714",
    d: "M8.75,1.25h-5A1.25,1.25,0,0,0,2.5,2.5v10a1.25,1.25,0,0,0,1.25,1.25h7.5A1.25,1.25,0,0,0,12.5,12.5V5Z",
    fill: "none",
    stroke: "#043f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35715",
    "data-name": "Path 35715",
    d: "M8.75,1.25V5H12.5",
    fill: "none",
    stroke: "#043f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35716",
    "data-name": "Path 35716",
    d: "M10,8.125H5",
    fill: "none",
    stroke: "#043f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35717",
    "data-name": "Path 35717",
    d: "M10,10.625H5",
    fill: "none",
    stroke: "#043f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35718",
    "data-name": "Path 35718",
    d: "M6.25,5.625H5",
    fill: "none",
    stroke: "#043f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.4bb392ebad446da5ef463cd234bb38e1.svg";
export { ForwardRef as ReactComponent };